<template>
  <LayoutJps v-if="isJps">
    <NuxtPage />
  </LayoutJps>
  <LayoutHina v-else-if="isHina">
    <NuxtPage />
  </LayoutHina>
</template>

<script lang="ts" setup>
const { siteName } = useSite()
const { isEn } = useI18n()
const { isJps, isHina, serviceType } = useServiceType()

const prefix = '/assets/' + serviceType + '/'

useHead({
  htmlAttrs: {
    lang: () => (isEn.value ? 'en' : 'ja'),
  },
  link: [
    {
      rel: 'icon',
      href: prefix + 'favicon/favicon.ico',
    },
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: prefix + 'favicon/favicon.svg',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: prefix + 'favicon/apple-touch-icon.png',
    },
    {
      rel: 'mask-icon',
      href: prefix + 'favicon/mask-icon.svg',
      color: '#FFFFFF',
    },
  ],
  meta: [{ property: 'og:site_name', content: siteName() }],
})
</script>
